import $ from 'jquery';
import { $header } from '../header/header.js';
import loader from '../loader/loader.js';

$( () => {
	// Поиск
	( () => {
		const $input = $( '.news__search-input' );

		if ( ! $input.length ) {
			return;
		}

		// Показать/скрыть кнопку очистки поля
		$input
			.on( 'input', () => {
				if ( $input.val().trim() ) {
					$input.addClass( 'news__search-input_filled' );
				} else {
					$input.removeClass( 'news__search-input_filled' );
				}
			} )
			.trigger( 'input' );

		// Очистить поле
		$( '.news__search-clear' ).on( 'click', () => {
			$input.val( '' ).trigger( 'input' );
		} );
	} )();

	// Записи
	( () => {
		const $news = $( '.news' );

		if ( ! $news.length ) {
			return;
		}

		const $box        = $( '.news__box' );
		const $order      = $( '[name="order"]' );
		const $pagination = $( '.pagination' );
		const $body       = $( 'html, body' );
		const $head       = $( '.page__head' );

		const defaultState = {
			order:          $order.val(),
			boxHTML:        $box.prop( 'outerHTML' ),
			paginationHTML: $pagination.prop( 'outerHTML' ),
		};

		function update( state ) {
			$order.val( state.order ).trigger( 'update' );
			$pagination.html( $( state.paginationHTML ).html() );
			$box.children( '.short-news' ).remove();
			$box.append( $( state.boxHTML ).children( '.short-news' ) );
		}

		function load( url ) {
			$.get( url, loader( $box, ( html ) => {
				const $html = $( html );
	
				const state = {
					order:          $order.val(),
					boxHTML:        $html.find( '.news__box' ).prop( 'outerHTML' ),
					paginationHTML: $html.find( '.pagination' ).prop( 'outerHTML' ),
				};
	
				history.pushState( state, null, url );
				update( state );
			} ) );
		}

		// Загрузка записей при изменение сортировки
		$order.on( 'change', () => {
			load( location.href.split( '?' )[0].replace( /page\/(.*?)\//, '' ) + '?order=' + $order.val() );
		} );

		// Загрузка записей при изменение номера страницы
		$news.on( 'click', '.pagination__link', function( e ) {
			e.preventDefault();
			load( $( this ).attr( 'href' ) );
			$body.animate( { scrollTop: $head.offset().top + $head.outerHeight() - $header.outerHeight() } );
		} );

		// Изменение контента при переходе по истории браузера
		window.addEventListener( 'popstate', ( e ) => {
			update( e.state ? e.state : defaultState );
		} );
	} )();
} );
